import Utils from '../Utils';

// Dependencies
import Ads from './dependencies/Ads.js';
import Analytics from './dependencies/Analytics.js';
window.Analytics = Analytics;
import AnchorLinks from './dependencies/AnchorLinks.js';
import Breadcrumb from './dependencies/Breadcrumb.js';
import Collapse from './dependencies/Collapse.js';
import CopyClipboard from './dependencies/CopyClipboard.js';
import DedicatedSpace from './dependencies/DedicatedSpace.js';
import PrintList from './dependencies/PrintList.js';
import Form from './dependencies/Form.js';
import FormValidation from './dependencies/FormValidation.js';
import MainMinHeight from './dependencies/MainMinHeight.js';
import Menu from './dependencies/Menu.js';
import Modal from './dependencies/Modal.js';
import Navigation from './dependencies/Navigation.js';
import PdfViewer from './dependencies/PdfViewer.js';
import Popin from './dependencies/Popin.js';
import Quiz from './dependencies/Quiz.js';
import QuizCertificate from './dependencies/QuizCertificate.js';
import QuizPositioning from './dependencies/QuizPositioning.js';
import ResponsiveIframe from './dependencies/ResponsiveIframe.js';
import Sticky from './dependencies/Sticky.js';
import StickyHeader from './dependencies/StickyHeader.js';
import Summary from './dependencies/Summary.js';
import Tabs from './dependencies/Tabs.js';
import Tiles from './dependencies/Tiles.js';
import Toggle from './dependencies/Toggle.js';
import VideoPlaylist from './dependencies/VideoPlaylist.js';
import Webshop from './dependencies/Webshop.js';
import Progress from './dependencies/Progress';
import VocalReader from "./dependencies/VocalReader";

const onScriptLoadDependencies = [
    ResponsiveIframe
];

const onPageLoadDependencies = [
    Ads,
    Analytics,
    AnchorLinks,
    Breadcrumb,
    Collapse,
    CopyClipboard,
    DedicatedSpace,
    Form,
    PrintList,
    Progress,
    FormValidation,
    MainMinHeight,
    Menu,
    Modal,
    Navigation,
    PdfViewer,
    Popin,
    Quiz,
    QuizCertificate,
    QuizPositioning,
    Sticky,
    StickyHeader,
    Summary,
    Tabs,
    Tiles,
    Toggle,
    VideoPlaylist,
    VocalReader,
    Webshop
];

// On script load
onScriptLoadDependencies.forEach(dependency => dependency.initializeEvents());

// On page load
Utils.onReady(() => {
    onPageLoadDependencies.forEach(dependency => dependency.initializeEvents());
});